import extension from "@local/extensions/utilities/extension.js";
import nameMinusExtension from "@local/extensions/utilities/name-minus-extension.js";

import type { TablesGenerated } from "../database.js";

type Attachment = TablesGenerated<"attachments">;
type Location = TablesGenerated<"locations">;
type Group = TablesGenerated<"groups">;

function createClipAttachment(group: Group, location: Location) {
  const { id, document_id, page_id } = location;
  const document = group.documents[document_id];
  const page = document?.data.pages[page_id];
  const pageIndex = document?.data.pages.indices[page_id];

  return {
    type: "clip",
    id,
    document_id,
    page_id,
    location,
    object_name: page?.name,
    object_page: page?.page,
    extension: extension(page?.name),
    name: `Clip: ${document?.name} - ${pageIndex + 1}`,
  };
}

type ClipAttachment = ReturnType<typeof createClipAttachment>;

function createIIIFDrawing(attachment: ClipAttachment) {
  if (!attachment.object_name) throw new Error("No object_name for clip.");
  if (!attachment.location.position) throw new Error("No position for clip.");

  const path = `${nameMinusExtension(attachment.object_name)}.${attachment.object_page}.tiff`;

  return {
    attachment_id: attachment.id,
    id: attachment.object_name.split("/")[0],
    name: attachment.name,
    type: "iiif",
    path,
    clip: attachment.location.clip,
    extension: "pdf",
    properties: {
      // @ts-ignore
      width: attachment.location.clip.width,
      // @ts-ignore
      height: attachment.location.clip.height,
    },
  };
}

export { createClipAttachment, createIIIFDrawing };
